// extracted by mini-css-extract-plugin
export var closeButton = "_q3-2";
export var closeButtonIcon = "_q3-3";
export var lightboxContent = "_q3-1";
export var lightboxOverlay = "_q3-0";